import { useNavigate, useParams } from 'react-router-dom';
import { Layout } from '../../components/Layout/Layout';
import { Chat } from '../../containers/Chat/Chat';
import { useAppSelector } from '../../hooks';
import { selectCurrentChat } from '../../containers/ChatsList/chatListSlice';
import { useEffect, useState } from 'react';
import { getHeaderBackgroundColor } from '../../containers/Chat/helpers';

export const ChatMessages = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const message = useAppSelector(selectCurrentChat);
  const [headerBackgroundColor, setHeaderBackgroundColor] = useState<undefined | string>(undefined);

  useEffect(() => {
    if (message) setHeaderBackgroundColor(getHeaderBackgroundColor(message));
  }, [message, message?.type, message?.emergencyTypeColor, message?.recalled]);

  const handleDots = () => {
    navigate(`/message-details/${id}`);
  };

  return (
    <Layout
      isMessageLayout
      to={'/chat'}
      noTranslate
      showDots
      headerBackgroundColor={headerBackgroundColor}
      dotsCallBack={handleDots}
      handleHeaderContentClick={handleDots}
    >
      <Chat id={id!} setSubMessage />
    </Layout>
  );
};
